<template>
    <footer id="foot">
        <div class="footMain">
            <p>
                Copyright© 2012-2024 
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42011102001731" style="color: #fff;" target="_blank" rel="nofollow"><img src="../assets/beian_icon.png" style=" width: 14px; margin: -2px 5px 0 0; vertical-align: middle;">鄂公网安备42011102001731号</a>
                <a href="https://beian.miit.gov.cn" style=" color: inherit; " target="_blank" rel="nofollow">鄂ICP备15010922号-1</a>
            </p>
            <nav>
                <router-link to="/home">首页</router-link>
                <router-link to="/service/serviceList">服务</router-link>
                <router-link to="/about">关于</router-link>
                <router-link to="/cases">案例</router-link>
                <router-link to="/cantact/cantactMap">联系</router-link>
            </nav>
        </div>
        <nav class="mobileNav">
            <ul>
                <li>
                    <div>
                        <a href="tel:13659833803"><i class="iconfont icon-msnui-telephone"></i><p>电话咨询</p></a>
                    </div>
                </li>
                <li>
                    <div>
                        <router-link to="/wluotxMap"><i class="iconfont icon-dingwei"></i><p>在线地图</p></router-link>
                    </div>
                </li>
                <li>
                    <div>
                        <a href="http://wpa.qq.com/msgrd?v=3&uin=2834579326&site=qq&menu=yes"><i class="iconfont icon-iconfonticon6"></i><p>QQ客服</p></a>
                    </div>
                </li>
            </ul>
        </nav>        
        <!-- 功能按钮 -->
        <div class="goTop" @click="goTop">
            <i class="iconfont icon-jiantou-copy"></i>
        </div>
    </footer>
</template>

<script>
export default {
    data(){
        return{}
    },
    beforeEach(to,from,next){
        next()
    },
    methods: {
        goTop(){
            document.body.scrollTop = 0
        },
        toTop(){
            window.scrollTo(0,0);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- lang="less"后 可编写less ，默认的cli无less-loader包，需自行安装 -->
<!-- scoped 的作用为限定css的作用域，防止污染 -->
<style scoped lang="less">
#foot{
    height: 80px;
    line-height: 80px;
    background: #1577e4;
}
.footMain{
    width: 960px;
    height: 80px;
    margin: 0 auto;
    color: #fff;
    font-size: 14px;
    a{
        color: #fff;
    }
    p{
        float: left;
    }
    nav{
        float: right;
        a{
            padding: 0 27px;
            &:last-of-type{
                padding-right: 14px;
            }
        }
    }
}
.goTop{
    display: none;
    width: 35px;
    height: 35px;
    line-height: 35px;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    bottom: 100px;
    right: 20px;
    transform: rotateZ(-90deg);
    -ms-transform: rotateZ(-90deg);
}
.mobileNav{
    display: none;
    width: 100%;
    height: 60px;
    background: #1577e4;
    position: fixed;
    bottom: 0;
    left: 0;
    a{
        display: block;
        width: 100%;
        height: 100%;
        color: #fff;
    }
    li{
        width: 33.333%;
        padding-top: 5px;
        text-align: center;
        float: left;
    }
    i{
        display: inline;
        font-size: 26px;
        line-height: 26px;
    }
    p{
        font-size: 14px;
        line-height: 20px;
    }
}
::-moz-selection{background:#ccc; color:#fff;}
::selection {background:#ccc; color:#fff;}
@media only screen and (max-width:750px) {
    #foot{
        height: 196px;
        line-height: 24px;
        padding-top: 40px;
        background: #fff;
    }
    .footMain{
        width: 100%;
        height: auto;
        color: #000;
        p{
            width: 100%;
            text-align: center;
            padding-bottom: 19px;
        }
        a {
            display: block;
            color: #000!important;
        }
        nav{
            display: none;
        }
    }
    .goTop{
        display: block;
    }
    .mobileNav{
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mfoot.vue